import { 
    SET_USER_DATA,
    SET_USER_RIGHTS,
    SET_USER_CAMERAS,
    LOGOUT_USER,
    EXPIRE_SESSION
  } from '../actions/types';
  
  const INITIAL_STATE = {
    bID: 0,
    sName: '',
    sDescription: '',
    sPassword: '',
    bType: 0,
    bInactivityTimeout: 0,
    bRole: null,          // cloud MASTER BIT (rights-acl §2): 1 = Dividia master → full access, rights bitmask ignored; 0 = non-master → capabilities come from the rights below (fAdmin/fPlayback/…); null = local (no cloud role)
    userRights: [],
    fAccess: 0,
    fAdmin: 0,
    fExport: 0,
    fRemote: 0,
    fPtz: 0,
    fPlayback: 0,
    userCameras: []
  };
  
  export default function userReducer(state = INITIAL_STATE, action) {
    switch ( action.type ) {
        case LOGOUT_USER:
            return { 
                ...state, 
                bID: 0,
                sName: '',
                sDescription: '',
                sPassword: '',
                bType: 0,
                bInactivityTimeout: 0,
                bRole: null,
                userRights: [],
                fAccess: 0,
                fAdmin: 0,
                fExport: 0,
                fRemote: 0,
                fPtz: 0,
                fPlayback: 0,
                userCameras: []
            }
        case EXPIRE_SESSION:
            return { 
                ...state, 
                bID: 0,
                sName: '',
                sDescription: '',
                sPassword: '',
                bType: 0,
                bInactivityTimeout: 0,
                bRole: null,
                userRights: [],
                fAccess: 0,
                fAdmin: 0,
                fExport: 0,
                fRemote: 0,
                fPtz: 0,
                fPlayback: 0,
                userCameras: []
            }
        case SET_USER_DATA:
            return {
                ...state,
                bID: action.payload,
                sName: action.sName,
                sDescription: action.sDescription,
                sPassword: action.sPassword,
                bType: action.bType,
                bInactivityTimeout: action.bInactivityTimeout,
                bRole: action.bRole != null ? action.bRole : null
            }
        case SET_USER_RIGHTS:
            return { 
                ...state, 
                fAccess: action.fAccess,
                fAdmin:  action.fAdmin,
                fExport:  action.fExport,
                fRemote:  action.fRemote,
                fPtz:  action.fPtz,
                fPlayback:  action.fPlayback
            }
        case SET_USER_CAMERAS:
            return { 
                ...state, 
                userCameras: action.payload
            }
        default:
            return state;
    };
  };